import React, { useEffect, useState } from "react";
import PropTypes from "prop-types";
import {
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  List,
  ListItem,
  ListItemIcon,
  Checkbox,
  ListItemText,
  ListItemSecondaryAction,
} from "@material-ui/core";
import { makeStyles, createStyles } from "@material-ui/core/styles";
import classNames from "classnames";
import {
  AddCircle as AddCircleIcon,
} from "@material-ui/icons";
import uniq from "lodash/uniq";

import { StyledButton } from "../core";
import { CollectionCreateDialog } from "../CollectionsDialog";
import { DialogTitle } from "../core";

// context
import { useSnackbar } from "notistack";
import { useUserState } from "../../context/UserContext";
import {
  useCollectionDispatch,
  useCollectionState,
} from "../../context/CollectionContext";

import { updateVideoCollections } from "../../clientAPI";
import { useVideoCollections } from "../../useGlobal";

const useStyles = makeStyles(theme =>
  createStyles({
    root: {},
    paper: {
      borderRadius: 10,
      width: 440,
    },
    collectionsContainer: {
      maxHeight: 300,
    },
    titleRoot: {
      display: "flex",
      alignItems: "center",
      justifyContent: "space-between",
      padding: "32px 32px",
      paddingTop: theme.spacing(5),
      paddingBottom: theme.spacing(3),
    },
    title: {
      color: "black",
      fontSize: 18,
      fontWeight: 500,
    },
    titleCloseButton: {
      fontSize: 20,
      cursor: "pointer",
    },
    titleChild: {
      display: "inline-flex",
    },
    dialogActions: {
      justifyContent: "space-between",
      padding: "16px 32px 16px 32px",
    },
    diaglogActionButtonText: {
      fontSize: 14,
    },
    diaglogActionButton: {},
    hidden: {
      display: "none",
    },
  }),
);

const VideoCollectionDialog = ({
  videoId,
  open,
  onClose,
  status,
  checkedIds,
}) => {
  const classes = useStyles();
  const {
    creatingDialogFromVideoColDialog,
    createdColID,
  } = useCollectionState();
  const { enqueueSnackbar } = useSnackbar();
  const collectionDispatch = useCollectionDispatch();
  const { isAuthenticated } = useUserState();
  const { videoCollections, setVideoCollections } = useVideoCollections(
    videoId,
    isAuthenticated,
  );

  const [checked, setChecked] = useState([]);
  const [unchecked, setUnchecked] = useState([]);
  const [openCreateDialog, setOpenCreateDialog] = useState(false);

  const expected = uniq([...checkedIds, ...checked]).filter(
    value => unchecked.indexOf(value) === -1,
  );

  const handleClose = () => {
    onClose();
    setChecked([]);
    setUnchecked([]);
    collectionDispatch({
      type: "CREATE_COLLECTION_DONE",
    });
    collectionDispatch({ type: "RESET_DIALOG_COLLECTION_ID" });
  };

  const handleToggle = value => () => {
    const collected = checkedIds.indexOf(value) !== -1;

    const newChecked = [...checked];
    const newUnchecked = [...unchecked];

    const inChecked = newChecked.indexOf(value) !== -1;
    const inUnchecked = newUnchecked.indexOf(value) !== -1;

    if (!collected) {
      if (inChecked) {
        newChecked.pop(value);
      } else {
        newChecked.push(value);
      }
    } else {
      if (inUnchecked) {
        newUnchecked.pop(value);
      } else {
        newUnchecked.push(value);
      }
    }

    setChecked(newChecked);
    setUnchecked(newUnchecked);
  };

  useEffect(() => {
    if (!creatingDialogFromVideoColDialog && createdColID) {
      handleToggle(createdColID)();
      collectionDispatch({ type: "RESET_DIALOG_COLLECTION_ID" });
    }
  }, [creatingDialogFromVideoColDialog]);

  const CollectionList = () => (
    <List className={classes.collectionsContainer}>
      {status.map(value => {
        const labelId = `checkbox-list-label-${value.id}`;
        return (
          <ListItem
            key={value.id}
            role={undefined}
            dense
            button
            onClick={handleToggle(value.id)}
          >
            <ListItemIcon>
              <Checkbox
                edge='start'
                color='primary'
                checked={expected.indexOf(value.id) !== -1}
                tabIndex={-1}
                disableRipple
                inputProps={{ "aria-labelledby": labelId }}
              />
            </ListItemIcon>
            <ListItemText id={labelId} primary={value.name} />
            <ListItemSecondaryAction></ListItemSecondaryAction>
          </ListItem>
        );
      })}
    </List>
  );

  return (
    <>
      <Dialog
        onClose={handleClose}
        aria-labelledby='simple-dialog-title'
        open={open}
        className={classNames({
          [classes.hidden]: creatingDialogFromVideoColDialog,
        })}
        classes={{ paper: classes.paper }}
      >
        <DialogTitle id='simple-dialog-title'>新增至收藏</DialogTitle>
        <DialogContent>
          <CollectionList />
        </DialogContent>
        <DialogActions className={classes.dialogActions}>
          <Button
            className={classes.diaglogActionButtonText}
            color='primary'
            onClick={() => {
              setOpenCreateDialog(true);
              collectionDispatch({ type: "CREATE_COLLECTION_DOING" });
            }}
            startIcon={<AddCircleIcon />}
          >
            建立資料夾
          </Button>
          <StyledButton
            variant='tag'
            onClick={() => {
              updateVideoCollections({
                video_id: videoId,
                expected_ids: expected,
              })
                .then(data => {
                  const createIds = data.create.map(e => e.collection_id);
                  const deleteIds = data.delete.map(e => e.collection_id);
                  const isCollected = (collectionId, originVal) => {
                    if (createIds.indexOf(collectionId) !== -1) {
                      return true;
                    }
                    if (deleteIds.indexOf(collectionId) !== -1) {
                      return false;
                    }
                    return originVal;
                  };

                  const newVideoCollections = {
                    video_id: videoCollections.video_id,
                    collections: videoCollections.collections.map(elm => ({
                      ...elm,
                      collected: isCollected(elm.id, elm.collected),
                    })),
                  };
                  enqueueSnackbar("收藏已成功更新", { variant: "success" });
                  handleClose();
                  setVideoCollections(newVideoCollections, true);
                })
                .catch(err => {
                  console.log(err);
                });
            }}
          >
            儲存
          </StyledButton>
        </DialogActions>
      </Dialog>
      <CollectionCreateDialog
        open={openCreateDialog}
        setOpen={setOpenCreateDialog}
        videoId={videoId}
      />
    </>
  );
};

VideoCollectionDialog.defaultProps = {};

VideoCollectionDialog.propsTypes = {};

export default VideoCollectionDialog;
